var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.30968 4.30965C5.61144 3.00791 7.72198 3.00791 9.02374 4.30965L75.6904 70.9763C76.992 72.278 76.992 74.3887 75.6904 75.6903C74.3887 76.992 72.278 76.992 70.9764 75.6903L4.30968 9.02371C3.00794 7.72195 3.00794 5.61141 4.30968 4.30965Z",
    fill: "#FF756C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8467 13.127C12.4841 18.4071 9.16663 25.6101 9.16663 33.6023C9.16663 42.6277 13.5906 49.2897 18.9121 54.967C21.1945 57.4023 23.7082 59.724 26.1485 61.9777L26.1608 61.989C26.544 62.343 26.9254 62.6953 27.3039 63.046C30.1317 65.6673 32.8187 68.2287 35.1173 70.9623C37.615 73.9323 42.3693 74.0317 44.9526 71.0757C47.311 68.3777 50.027 65.809 52.864 63.1573L53.383 62.6723C55.7633 60.4487 58.2156 58.1583 60.4776 55.758L49.287 44.5673C46.886 46.8983 43.6106 48.3333 40 48.3333C32.6362 48.3333 26.6666 42.3637 26.6666 35C26.6666 31.3894 28.1018 28.114 30.4327 25.7131L17.8467 13.127Z",
    fill: "#FF756C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1933 40.4027C52.9263 38.7513 53.3333 36.923 53.3333 35C53.3333 27.6362 47.3637 21.6667 40 21.6667C38.077 21.6667 36.2487 22.0738 34.5973 22.8066L21.7015 9.91076C26.835 6.29512 33.1745 4.16666 40 4.16666C56.908 4.16666 70.8333 17.2278 70.8333 33.6023C70.8333 40.9787 67.8213 46.883 63.7707 51.98L52.1933 40.4027Z",
    fill: "#FF756C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.d1a5c1fa6939c849e53cd4a58d22d0ef.svg";
export { ForwardRef as ReactComponent };